var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"loading":_vm.loading,"search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }